<h1 mat-dialog-title><span *ngIf="!data.active">Activate</span> <span *ngIf="data.active">Deactivate</span> Location</h1>
<div mat-dialog-content>
  <div>
    <p>You're going to <span *ngIf="!data.active">activate</span> <span *ngIf="data.active">deactivate</span> location: "{{ data.name }}"</p>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-button [mat-dialog-close]="data" cdkFocusInitial>Confirm</button>
</div>



